import { Container, Grid, Typography } from "@material-ui/core";
// export 'default' (imported as 'Label') was not found in '@devexpress/dx-react-chart-material-ui' (possible exports: AreaSeries, ArgumentAxis, BarSeries, Chart, Legend, LineSeries, PieSeries, ScatterSeries, SplineSeries, Title, Tooltip, ValueAxis, ZoomAndPan)
import { PersonAddOutlined } from "@material-ui/icons";
import axios from "axios";
import CardBox from "../Main/Card";
import Constants from "../Variables/Constants";
// import Card from '@material-ui/core/Card';
// import CardActions from '@material-ui/core/CardActions';
// import CardContent from '@material-ui/core/CardContent';
// import Button from '@material-ui/core/Button';
// import Typography from '@material-ui/core/Typography';
// import "../../App.css";
import "../../App.css";

import React, { Component } from "react";
// const socket = io.connect("http://localhost:8084");

export default class Dashboard extends Component {
  state = {
    totalUsers: "",
    runningContests: 0,
    cpu: "",
    memory: "",
    client_count: 0,
    bank_added: 0,
    cash_bonus: 0,
    winnings: 0,
    total_withdrawn: 0,
    users_bankAdded: "",
    users_cashbonus: "",
    referal_bonus: "",
    users_referalBonus: "",
    data: [],
    limit: 10,
    page: 1,
    nextPage: false,
    prevPage: false,
    totaldocs: 0,
    totalpage: 1,
    dashboard: {},

    total: 0,
  };

  // handleChange = (event) => {
  //   this.setState({
  //     spacing: Number(event.target.value),
  //   });
  // };

  componentDidMount() {
    this.getData();
    this.getDashboardData();
  }

  getData = () => {
    axios
      .get(
        Constants.getUrls.getUserList +
          `?limit=${this.state.limit}` +
          `&page=${this.state.page}`
      )
      .then((resp) => {
        this.setState(
          {
            getAllUsers: resp.data.data,
            limit: resp.data.pagination?.limit,
            nextPage: resp.data.pagination?.nextpage,
            page: resp.data.pagination?.page,
            prevPage: resp.data.pagination?.prevpage,
            totalpage: resp.data.pagination?.totalpage,
            total: resp.data.pagination?.total,

            empty: resp.data.message === "No Search Found!" ? true : false,
          },

          () => {
            // console.log(this.state.limit);
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getDashboardData = () => {
    axios
      .get(Constants.getUrls.dashboard)
      .then((resp) => {
        this.setState({ dashboard: resp.data.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  render() {
    const { data: chartData } = this.state;

    return (
      <>
        <Container maxWidth={"xl"}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography variant="h5">Dashboard</Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} style={{ marginTop: "30px" }}>
            <CardBox
              name={"Total Users"}
              icon={<PersonAddOutlined size={"small"} />}
              value={this.state.total}
              // icon={<DoneAllIcon style={{ fontSize: "30" }} />}
              color={"#6c6cff"}
              shadow={" 247, 220, 111"}
            />
            <CardBox
              name={"Category"}
              icon={<PersonAddOutlined size={"small"} />}
              value={this.state.dashboard?.categories}
              // icon={<DoneAllIcon style={{ fontSize: "30" }} />}
              color={"#6c6cff"}
              shadow={" 247, 220, 111"}
            />
            <CardBox
              name={"Un Read Enquiries"}
              icon={<PersonAddOutlined size={"small"} />}
              value={this.state.dashboard?.unread_enquiry}
              // icon={<DoneAllIcon style={{ fontSize: "30" }} />}
              color={"#6c6cff"}
              shadow={" 247, 220, 111"}
            />{" "}
             <CardBox
              name={"Today's Enquiries"}
              icon={<PersonAddOutlined size={"small"} />}
              value={this.state.dashboard?.todays_enquiry}
              // icon={<DoneAllIcon style={{ fontSize: "30" }} />}
              color={"#6c6cff"}
              shadow={" 247, 220, 111"}
            />{" "}
            <CardBox
              name={"Products"}
              icon={<PersonAddOutlined size={"small"} />}
              value={this.state.dashboard?.product}
              // icon={<DoneAllIcon style={{ fontSize: "30" }} />}
              color={"#6c6cff"}
              shadow={" 247, 220, 111"}
            />{" "}
            <CardBox
              name={"Order Placed"}
              icon={<PersonAddOutlined size={"small"} />}
              value={this.state.dashboard?.placed_order}
              // icon={<DoneAllIcon style={{ fontSize: "30" }} />}
              color={"#6c6cff"}
              shadow={" 247, 220, 111"}
            />{" "}
            {/* <CardBox
              name={"Order Picked"}
              icon={<PersonAddOutlined size={"small"} />}
              value={this.state.dashboard?.order_picked}
              // icon={<DoneAllIcon style={{ fontSize: "30" }} />}
              color={"#6c6cff"}
              shadow={" 247, 220, 111"}
            /> */}
            <CardBox
              name={"All Orders"}
              icon={<PersonAddOutlined size={"small"} />}
              value={this.state.dashboard?.all_order}
              // icon={<DoneAllIcon style={{ fontSize: "30" }} />}
              color={"#6c6cff"}
              shadow={" 247, 220, 111"}
            />
            <CardBox
              name={"Cancelled Order"}
              icon={<PersonAddOutlined size={"small"} />}
              value={this.state.dashboard?.cancel_orders}
              // icon={<DoneAllIcon style={{ fontSize: "30" }} />}
              color={"#6c6cff"}
              shadow={" 247, 220, 111"}
            />
          </Grid>
        </Container>
      </>
    );
  }
}
